import { ActionTree } from 'vuex';
import ActionTypes from '@/constants/action-types';
import { RootState } from '@/store/state';
import { orderApiService } from '@/api';
import { OrderState } from '@/store/modules/order/state';
import { CurbsideModel } from '@/models/CurbsideModel';
import { OrderReceiptModel } from '@/models/OrderReceiptModel';

const actions: ActionTree<OrderState, RootState> = {

  async [ActionTypes.GetOrderReceipt]({ commit }, orderId: number) {
    const receipt: OrderReceiptModel = await orderApiService.receipt(orderId);
    return commit(ActionTypes.GetOrderReceipt, receipt);
  },

  async [ActionTypes.SaveCurbsideData](
    { commit },
    payload: { orderId: number; curbsideData: CurbsideModel },
  ) {
    return orderApiService.curbsidePickup(payload.orderId, payload.curbsideData);
  },

};

export default actions;
